/* ck-price-ticker
   Animates PDP price numbers on variant change instead of instant swap.
   Hooks the theme's `krown:variant:change` event (component-product-form.js
   line 431). Theme already updates DOM to the new variant by the time the
   event fires, so we animate from OLD to NEW over ~500ms ease-out cubic.

   Targets:
   - Main price blocks: [data-update-block="price-{compact,extended,sticky}-main"]
   - Afterpay instalment text: .ck-afterpay-messaging__text (divided by 4) */
(function () {
  'use strict';

  var PRICE_SELECTOR = '[data-update-block="price-compact-main"], [data-update-block="price-extended-main"], [data-update-block="price-sticky-main"]';
  var AFTERPAY_SELECTOR = '.ck-afterpay-messaging__text';
  var DURATION = 500;
  var PRICE_RE = /\$\d[\d,]*\.?\d*/;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function formatCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function replaceFirstPriceText(root, formatted) {
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walk.nextNode())) {
      if (PRICE_RE.test(node.textContent)) {
        node.textContent = node.textContent.replace(PRICE_RE, formatted);
        return;
      }
    }
  }

  function snapshotHtml(nodes) {
    var out = [];
    for (var i = 0; i < nodes.length; i++) out.push(nodes[i].innerHTML);
    return out;
  }

  function restoreHtml(nodes, snapshot) {
    for (var i = 0; i < nodes.length; i++) nodes[i].innerHTML = snapshot[i];
  }

  function tickTo(fromCents, toCents) {
    if (fromCents === toCents) return;

    var priceBlocks = document.querySelectorAll(PRICE_SELECTOR);
    var afterpayBlocks = document.querySelectorAll(AFTERPAY_SELECTOR);
    if (priceBlocks.length === 0 && afterpayBlocks.length === 0) return;

    var priceFinal = snapshotHtml(priceBlocks);
    var afterpayFinal = snapshotHtml(afterpayBlocks);

    var start = performance.now();
    function step(now) {
      var progress = Math.min(1, (now - start) / DURATION);
      var eased = easeOutCubic(progress);
      var curCents = Math.round(fromCents + (toCents - fromCents) * eased);
      var priceFormatted = formatCents(curCents);
      var quarterFormatted = formatCents(Math.round(curCents / 4));

      for (var i = 0; i < priceBlocks.length; i++) {
        replaceFirstPriceText(priceBlocks[i], priceFormatted);
      }
      for (var j = 0; j < afterpayBlocks.length; j++) {
        replaceFirstPriceText(afterpayBlocks[j], quarterFormatted);
      }

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        restoreHtml(priceBlocks, priceFinal);
        restoreHtml(afterpayBlocks, afterpayFinal);
      }
    }
    requestAnimationFrame(step);
  }

  function readFirstPriceCents() {
    var el = document.querySelector(PRICE_SELECTOR);
    if (!el) return null;
    var match = el.textContent.match(/\$([\d,]+\.?\d*)/);
    if (!match) return null;
    return Math.round(parseFloat(match[1].replace(/,/g, '')) * 100);
  }

  var lastCents = null;

  function init() {
    lastCents = readFirstPriceCents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('krown:variant:change', function (e) {
    var detail = e && e.detail;
    var newCents = detail && detail.variant && detail.variant.price;
    if (newCents == null) return;

    if (lastCents == null || lastCents === newCents) {
      lastCents = newCents;
      return;
    }

    requestAnimationFrame(function () {
      tickTo(lastCents, newCents);
      lastCents = newCents;
    });
  });
})();
